/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free YouTube thumbnail downloader. Paste any video URL to download the thumbnail in every resolution — maxres HD, SD, and standard sizes. No signup.`)
};

const es_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargador gratuito de miniaturas de YouTube. Pega la URL de cualquier video para descargar la miniatura en todas las resoluciones — maxres HD, SD y tamaños estándar. Sin registro.`)
};

const de_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser YouTube-Thumbnail-Downloader. URL einfügen und das Thumbnail in jeder Auflösung laden — maxres HD, SD und Standardgrößen. Keine Anmeldung nötig.`)
};

const nl_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis YouTube-thumbnail downloader. Plak een video-URL en download de thumbnail in elke resolutie — maxres HD, SD en standaardformaten. Geen account nodig.`)
};

const fr_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargeur de miniatures YouTube gratuit. Téléchargez la miniature de toute vidéo en HD maxres, SD et tailles standards. Sans inscription.`)
};

const it_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader gratuito di miniature YouTube. Incolla l'URL di un video per scaricarne la miniatura in ogni risoluzione — maxres HD, SD e dimensioni standard. Senza registrazione.`)
};

const pt_br2_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader gratuito de thumbnails do YouTube. Cole a URL do vídeo e baixe em todas as resoluções — maxres, HD, SD e padrão. Sem cadastro.`)
};

const pt_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader gratuito de miniaturas do YouTube. Cole qualquer URL de vídeo para descarregar a miniatura em todas as resoluções — maxres HD, SD e tamanhos padrão. Sem registo.`)
};

const ja_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のYouTubeサムネイルダウンローダー。動画URLを貼り付けるだけで、maxres HD、SD、標準サイズなどあらゆる解像度のサムネイルをダウンロードできます。登録不要。`)
};

const zh_yt_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 YouTube 缩略图下载器。粘贴任意视频链接，下载 maxres HD、SD 等所有分辨率的缩略图。无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_meta_description", locale)
	if (locale === "en") return en_yt_hub_meta_description(inputs)
	if (locale === "es") return es_yt_hub_meta_description(inputs)
	if (locale === "de") return de_yt_hub_meta_description(inputs)
	if (locale === "nl") return nl_yt_hub_meta_description(inputs)
	if (locale === "fr") return fr_yt_hub_meta_description(inputs)
	if (locale === "it") return it_yt_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_meta_description(inputs)
	if (locale === "pt") return pt_yt_hub_meta_description(inputs)
	if (locale === "ja") return ja_yt_hub_meta_description(inputs)
	return zh_yt_hub_meta_description(inputs)
};